module.exports = __webpack_public_path__ + "img/Sierra-Leone.014ac44a.svg";